import React, { lazy } from "react";

import Form from "../components/Form";
import LinkedInTag from "../components/LinkedInTag";

const Faq = lazy(() => import("../components/Faq"));

const FeaturesBenifits = lazy(() => import("../components/FeaturesBenifits"));
const AtmBranches = lazy(() => import("../components/AtmBranches"));
const FixDeposite = lazy(() => import("../components/FixDeposite"));
const DocumentRequired = lazy(() => import("../components/DocumentRequired"));

function Home({ customADL, setCustomADL }) {
  return (
    <>
      <Form customADL={customADL} setCustomADL={setCustomADL} />
      <LinkedInTag/>
      <FeaturesBenifits />
      <DocumentRequired />
      <AtmBranches />
      <FixDeposite />
      <Faq customADL={customADL} setCustomADL={setCustomADL} />
    </>
  );
}

export default Home;
